<!--Tarjeta en donde se muestra un video de youtube (CREO QUE YA NO  SE USA)-->
<template>
    <div class="view">
        <v-img src="@/assets/img/video-img.jpg"></v-img>
        <div class="mask">
            <v-dialog @click:outside="close()" v-model="dialog" width="800">
                <template v-slot:activator="{ on }">
                        <v-icon :style="getSize" color="white" class="playButton" v-on="on">fas fa-play</v-icon>
                </template>

                <v-card class="black pa-1">
                    <v-card-text class="pa-0">
                        <iframe ref="video" width="100%" style="height:50vh;" :src="video" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen autoplay></iframe>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        video: { type: String, required:true }
    },
    data(){
        return{
            dialog:false,
        }
    },
    methods:{
        close(){
            this.$refs.video.src = '';
            this.$refs.video.src = this.video;
        }
    },
    computed:{
        getSize(){
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 'font-size:3.5em'
                case 'sm': return 'font-size:3.5em'
                case 'md': return 'font-size:4em'
                case 'lg': return 'font-size:5em'
                case 'xl': return 'font-size:6em'
            }
        }
    }
}
</script>
<style scoped>
.view{
    position: relative;
    overflow: hidden;
    cursor: default;
}
.view img{
    position: relative;
    display: block;
}
.view .mask{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    width: 100%;
    height: 100%;
    background-attachment: fixed;
    background-color: rgba(29, 43, 59, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
}
.playButton{
    transition: 0.2s all ease-in-out;
} 
.playButton:hover{
    transform: scale(1.2)
} 

</style>